import gql from 'graphql-tag';

export const nightFragment = gql`
  fragment AdminNightData on AdminNight {
    _id
    night
    content
  }
`;
